import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize } = redesignTheme;

export const useMinorResultPieDiagramStyles = makeStyles(() => ({
  pieLegendList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 9,
    width: '100%',
  },
  pieLegendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  pieLegendSwatch: {
    width: 32,
    height: 21,
    borderRadius: 4,
    flexShrink: 0,
  },
  pieLegendLabel: {
    flex: 1,
    minWidth: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    lineHeight: 1.4,
    color: colors.overlay,
  },
}));
